<template>
  <h1 class="base-title">
    <slot />
  </h1>
</template>
<script>
export default {
    name: 'BaseTitle',
};
</script>
<style lang="scss">
.base-title{
    font-size: 1.5rem;
    text-transform: uppercase;
    color: #16507E;
}
</style>
